import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import cn from 'classnames';
import _ from 'lodash';
import viewForPath from './viewForPath';
import updateQuery from './updateQuery';

const pruneView = (query) => _.omitBy(query, (v) => parseInt(v) === 0);

const isSubset = (query, current) =>
  _.every(
    query,
    (v, k) => v === current[k] || (v === '0' && current[k] === undefined),
  );

class Link extends Component {
  static propTypes = {
    view: PropTypes.object,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    path: PropTypes.string,
    location: PropTypes.object,
  };

  static contextTypes = {
    allPages: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);

    this.makeUrl = this.makeUrl.bind(this);
    this.updateUrl = this.updateUrl.bind(this);
    this.goTo = this.goTo.bind(this);
  }

  makeUrl(query) {
    const queryString = _.toPairs(pruneView(query))
      .map((pair) => pair.join('='))
      .join('&');
    return `${this.props.location.pathname}?${queryString}`;
  }

  updateUrl(update) {
    const { location } = this.props;
    return this.makeUrl(
      updateQuery(location.query, update, this.context.allPages),
    );
  }

  goTo(query) {
    const href = this.props.disabled ? null : this.updateUrl(query);

    if (this.props.onClick) {
      this.props.onClick();
    }

    if (href) {
      this.props.router.replace(href);
    }
  }

  render() {
    const { view, path, className, children } = this.props;

    const query = view || viewForPath(path.split ? path.split('.') : path);
    const finalClass = cn(className, {
      active: isSubset(query, this.props.location.query),
    });

    return (
      <a
        onClick={() => this.goTo(query)}
        disabled={this.props.disabled}
        className={finalClass}
      >
        {children}
      </a>
    );
  }
}

export default withRouter(Link);
